import type { ResolvePublicBookingResponse } from "../services/resolvePublicBookingLink";

import { queryOptions } from "@tanstack/react-query";

import { resolvePublicBookingLink } from "../services/resolvePublicBookingLink";

const publicBookingLinkKeys = {
  root: ["publicBookingLink"] as const,
  bySlugAndCode: (slug: string, code: string) =>
    [...publicBookingLinkKeys.root, slug, code] as const,
};

export const publicBookingLinkQuery = (
  slug: string,
  code: string,
  placeholderData?: ResolvePublicBookingResponse,
) =>
  queryOptions({
    queryKey: publicBookingLinkKeys.bySlugAndCode(slug, code),
    queryFn: () => resolvePublicBookingLink(slug, code),
    staleTime: 300_000,
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: (query) =>
      query.state.status !== "error" || query.state.data !== undefined,
    placeholderData,
  });
